import { Directive, Input, OnInit, Optional } from '@angular/core';
import { DialogContainerComponent } from './dialog-container.component';
/* eslint-disable */

// Counter for unique dialog ids.
let uniqueId = 0;

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
@Directive({
    selector: 'ihd-dialog-title',
    host: {
        class: 'c-dialog__title',
        '[id]': 'id',
    },
})
export class DialogTitleComponent {
    @Input() id = `ihd-dialog-title-${uniqueId++}`;

    constructor(@Optional() private container: DialogContainerComponent) {}
}
